import { useParams } from "react-router";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { DocumentBlobCard } from "@/services/backend/filestorage/components/document-blob-card";
import { GSMServiceKind } from "@/services/backend/services/types/kinds";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { useHtzWorkOrderShowQuery } from "@/services/backend/htz/work-order/api/work-order-api";

/**
 * WorkOrderFilesRoute lists the files attached to an Arbeitsschein, e.g.
 * photos documenting the delivery of samples.
 */
export function WorkOrderFilesRoute() {
  const { workOrderId } = useParams();
  const {
    data: workOrder,
    isLoading,
    error,
  } = useHtzWorkOrderShowQuery({
    id: workOrderId!,
  });

  if (isLoading) {
    return null;
  }

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (!workOrder) {
    return null;
  }

  return (
    <DocumentBlobCard
      subdomain={GSMServiceKind.HTZ}
      documentKind={GSMDocumentKind.WorkOrder}
      documentId={workOrder.id}
      accept="application/pdf,image/jpeg,image/png"
      disabled={isImmutable(workOrder)}
    />
  );
}
